import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import SVGIcon from "common/SVGIcon";
import Progress from "common/ProgressCircle";
import { ANSWER_SOURCE, QUESTION_FLOW } from "lib/constants";
import { calculateMatchScore } from "lib/util";
import { showModal } from "redux/ws/actions";

import Questions from "./Questions";
import MatchScoreInfo from "./MatchScoreInfo";
import MatchesUnlockedModal from "./MatchesUnlockedModal";

const ANSWER_COUNT_FOR_POPUP = 20;

const mapStateToProps = ({ answerCount }) => ({
    answerCount,
});

class ProfileQuestions extends React.PureComponent {
    static propTypes = {
        answerCount: PropTypes.number.isRequired,
        showModal: PropTypes.func.isRequired,
    };

    state = {
        seenMatchesModal: this.props.answerCount >= ANSWER_COUNT_FOR_POPUP,
    };

    UNSAFE_componentWillReceiveProps({ answerCount }) {
        // eslint-disable-line
        if (
            !this.state.seenMatchesModal &&
            answerCount !== this.props.answerCount &&
            answerCount >= ANSWER_COUNT_FOR_POPUP
        ) {
            this.props.showModal(<MatchesUnlockedModal />);
            this.setState({ seenMatchesModal: true });
        }
    }

    render() {
        const matchScore = calculateMatchScore(this.props.answerCount);

        return (
            <div>
                <header className="questions__header">
                    <div className="questions__header-text">
                        <a href="/" aria-label="Back">
                            <SVGIcon icon="chevron-left" />
                        </a>
                        <div>Answer questions to improve your match score</div>
                    </div>
                    <Progress
                        className="mobile-only questions__header-score"
                        percentProgress={matchScore}
                        strokeWidth={3}
                        width={40}
                    >
                        <span className="progress-text">{matchScore}%</span>
                    </Progress>
                </header>
                <div className="content questions__content">
                    <Questions
                        autoSelect
                        canSkip
                        className="questions__content-left"
                        flow={QUESTION_FLOW.PROFILE}
                        source={ANSWER_SOURCE.PROFILE}
                    />
                    <div className="questions__content-right">
                        <MatchScoreInfo matchScore={matchScore} />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, { showModal })(ProfileQuestions);
